import {css} from "lit";
import {customScrollStyles} from "../../styles/CustomScrollBar.js";

// TODO: check loading box related styles
// TODO: check styles between pn-browser-ext and pn-www, in multiple less files
export const rteStyles = [customScrollStyles, css`
	.rich-text-editor-area {
		position: relative;
	}

	.rich-text-editor-area pn-loading-box {
		display: none;
		position: absolute;
		height: 100%;
		/** background-color: fadeout(@loading-box-overlay-bg-color, 80%); **/
		border-top-left-radius: 6px;
		border-top-right-radius: 6px;
	}

	.rich-text-editor-area .loading-box.loading {
		display: flex;
	}

	/** When there's just a div, emulated **/
	.rich-text-editor-area .dummy-editor {
		cursor: text;
	}

	.dummy-editor p:empty {
		/**  Give height (1.5 line-height) to an empty line so it doesn't
		shift things when the editor is clicked **/
		height: 18px;
	}

	/** Rich text editor is constructed **/
	.ProseMirror:read-only, .dummy-editor.disabled {
		background-color: var(--pn-gray-light);
		user-select: text;
		border: 1px solid transparent;
	}

	.ProseMirror, .dummy-editor {
		display: block;
		width: 100%;
		border: 1px solid var(--pn-input-border-color);
		border-top-left-radius: 6px;
		border-top-right-radius: 6px;
		padding: 12px;
		font-size: 14px;
		line-height: 1.5;
		color: var(--pn-input-text-color);
		box-sizing: border-box;
		overflow-y: auto;
		cursor: text;
		white-space: pre-wrap;
		overflow-wrap: break-word;
		font-family: var(--pn-font-family-base);
	}

	/** Styles for the text inside the editor **/
	#editor > * {
		overflow-wrap: break-word;
	}

	#editor p {
		margin: 0;
	}

	/* Placeholder */
	#editor p.is-editor-empty:first-child::before {
		position: absolute;
		margin-top: 2px;
		font-size: var(--pn-font-size-small);
		content: attr(data-placeholder);
		color: var(--pn-textarea-placeholder-text-color);
		pointer-events: none;

		/* 14px is the amount of padding on the bottom + the 2px margin */
		height: calc(100% - 14px);
		padding-right: 12px;
		overflow: hidden;
	}

	#editor ol, #editor ul {
		padding-left: 20px;
	}

	#editor blockquote {
		font-size: 14.5px;
	}

	/** Toolbar **/
	@keyframes slideDown {
		from {
			transform: translate3d(0, -10%, 0);
		}
		to {
			transform: translate3d(0, 0, 0);
		}
	}

	.rich-text-editor-toolbar {
		display: flex;
		flex: 0 0 auto;
		flex-wrap: nowrap;
		overflow-x: auto;
		border: 1px solid var(--pn-input-border-color);
		border-top: none;
		border-bottom-left-radius: 6px;
		border-bottom-right-radius: 6px;
		animation-name: slideDown;
		animation-duration: 0.3s;
	}

	.rich-text-editor-toolbar button {
		flex-shrink: 0;
		color: var(--pn-color-black);
		position: relative;
		margin: 6px;
		height: 20px;
		width: 20px;
		padding: 0;
		background-color: transparent;
		border: 1px solid transparent;
		border-radius: 4px;
		font-size: var(--pn-font-size-base);
	}

	.rich-text-editor-toolbar button:hover, .rich-text-editor-toolbar button:focus {
		border: 1px solid var(--pn-gray-dark);
	}

	.rich-text-editor-toolbar button.selected {
		background-color: lightblue;
	}

	.rich-text-editor-toolbar button.hidden {
		display: none;
	}

	.rich-text-editor-toolbar button.border-right::after {
		position: absolute;
		top: 0;
		right: 0;
		margin-right: -5px;
		content: "";
		height: 100%;
		width: 1px;
		background-color: var(--pn-input-border-color);
	}

	.rich-text-editor-toolbar button.editor-toolbar-btn-link {
		width: 32px;
	}

	.rich-text-editor-toolbar button.btn-emoji-picker {
		margin-left: auto;
	}

	.btn-emoji-picker + div {
		position: relative;
	}

	emoji-picker {
		position: absolute;
		z-index: 1;
		right: 28px;
		margin-top: 30px;
		box-shadow: 0 0 7px 0 rgba(0,0,0,.2);

		/* Set values so they match the web app, since this component uses
		 * rem internally, and the root font size is different on ext and www */
		--emoji-size: 22px;
		--emoji-padding: 8px;
		--indicator-height: 3px;
		--input-border-radius: 8px;
		--input-font-size: 16px;
		--input-padding: 4px;
		--skintone-border-radius: 16px;
		--category-font-size: 16px;
	}

	emoji-picker.hidden {
		display: none;
	}

	.hide-toolbar #editor, .ProseMirror:read-only {
		border-bottom-left-radius: 6px;
		border-bottom-right-radius: 6px;
	}

	.hide-toolbar .rich-text-editor-toolbar {
		display: none;
	}

	.hide-toolbar .loading-box {
		border-bottom-left-radius: 6px;
		border-bottom-right-radius: 6px;
	}

	.rich-text-editor-wrapper:hover .dummy-editor:not(.disabled),
	.rich-text-editor-wrapper:hover .ProseMirror:not(:read-only),
	.rich-text-editor-wrapper:focus-within .dummy-editor:not(.disabled),
	.rich-text-editor-wrapper:focus-within .ProseMirror:not(:read-only) {
		outline: none;
		border: 1px solid var(--pn-input-border-color-focus);
		border-bottom: 1px solid var(--pn-input-border-color);
	}

	.rich-text-editor-wrapper:hover .rich-text-editor-toolbar,
	.rich-text-editor-wrapper:focus-within .rich-text-editor-toolbar {
		border: 1px solid var(--pn-input-border-color-focus);
		border-top: none;
	}

	.rich-text-editor-wrapper:hover.hide-toolbar .ProseMirror:not(:read-only),
	.rich-text-editor-wrapper:focus-within.hide-toolbar .ProseMirror:not(:read-only),
	.rich-text-editor-wrapper:hover.hide-toolbar .dummy-editor:not(.disabled), .rich-text-editor-wrapper:focus-within.hide-toolbar .dummy-editor:not(.disabled) {
		border-bottom: 1px solid var(--pn-input-border-color-focus);
	}

	/** Annotation notes **/
	.dummy-editor {
		min-height: 30px;
	}

	/** TODO for pn-www outline?
	.dummy-editor, .ProseMirror {
		font-size: calc(var(--pn-font-size-base) + 1px);
		line-height: 1.4;
	}
	**/

	#editor:before, #editor:after {
		display: none; /* Fixes strange issues in specific sites where there are things in every div:before and div:after. */
	}

	.rich-text-editor-wrapper.pn-notes-wrapper.editable {
		/** In the sidebar, don't overlap with the three dots menu **/
		margin-right: 10px;
	}

	.rich-text-editor-wrapper.pn-notes-wrapper .rte-wrapper {
		/** Other styles **/
		line-height: 1.4;
		white-space: pre-wrap;
	}

	.rich-text-editor-wrapper.pn-notes-wrapper .rte-wrapper .dummy-editor,
	.rich-text-editor-wrapper.pn-notes-wrapper .rte-wrapper .ProseMirror {
		background-color: transparent;
		resize: none;
		overflow: hidden;
		height: auto;
	}

	.rich-text-editor-wrapper.pn-notes-wrapper .rte-wrapper .dummy-editor:read-only,
	.rich-text-editor-wrapper.pn-notes-wrapper .rte-wrapper .ProseMirror:read-only {
		background-color: transparent;
	}

	/** Borders and placeholders when hovering and focusing **/
	/* If the toolbar is hidden, also hide the borders */
	.pn-notes-wrapper.hide-toolbar .dummy-editor:not(.disabled),
	.pn-notes-wrapper.hide-toolbar .ProseMirror:not(:read-only) {
		border: 1px solid transparent;
	}

	/* Placeholders */
	.pn-notes-wrapper #editor p.is-editor-empty:first-child::before {
		position: absolute;
		opacity: 0;
	}

	/* Editable */
	.pn-notes-wrapper.editable:hover .rich-text-editor-toolbar,
	.pn-notes-wrapper.editable:focus-within .rich-text-editor-toolbar {
		border: 1px solid var(--pn-input-border-color);
		border-top: none;
	}

	.pn-notes-wrapper:hover.hide-toolbar .ProseMirror:not(:read-only),
	.pn-notes-wrapper.editable:hover.hide-toolbar .dummy-editor:not(.disabled) {
		border-bottom: 1px solid var(--pn-input-border-color);
	}

	.pn-notes-wrapper.editable:hover .dummy-editor:not(.disabled),
	.pn-notes-wrapper.editable:hover .ProseMirror:not(:read-only) {
		border: 1px solid var(--pn-input-border-color);
	}

	.pn-notes-wrapper.is-empty.editable:hover .dummy-editor:not(.disabled),
	.pn-notes-wrapper.is-empty.editable:hover .ProseMirror:not(:read-only) {
		border: 1px solid transparent;
	}

	.pn-notes-wrapper.editable:focus-within .dummy-editor:not(.disabled),
	.pn-notes-wrapper.editable:focus-within .ProseMirror:not(:read-only) {
		border: 1px solid var(--pn-input-border-color);
	}

	.pn-notes-wrapper.is-empty.editable:focus-within .dummy-editor:not(.disabled),
	.pn-notes-wrapper.is-empty.editable:focus-within .ProseMirror:not(:read-only) {
		border: 1px solid var(--pn-input-border-color);
	}

	.pn-notes-wrapper.editable:hover #editor p.is-editor-empty:first-child::before,
	.pn-notes-wrapper.editable:focus-within #editor p.is-editor-empty:first-child::before {
		opacity: 1;
	}

	/* Fade everything else a bit */
	.pn-notes-wrapper:focus-within ~ * {
		opacity: .5;
	}


	/** TODO: ?? **/
	.pn-notes-wrapper:hover.hide-toolbar .ProseMirror:not(:read-only),
	.pn-notes-wrapper:hover.hide-toolbar .dummy-editor:not(.disabled),
	.pn-notes-wrapper:focus-within.hide-toolbar .ProseMirror:not(:read-only),
	.pn-notes-wrapper:focus-within.hide-toolbar .dummy-editor:not(.disabled) {
		border-bottom: 1px solid var(--pn-input-border-color);
	}

	.pn-notes-wrapper #editor {
		padding: 3px 5px;
	}

	.pn-notes-wrapper.is-empty .dummy-editor:hover {
		border: 1px solid transparent;
	}
`];
